import { render, staticRenderFns } from "./SwModalWindow.vue?vue&type=template&id=6502bd47"
import script from "./SwModalWindow.vue?vue&type=script&lang=js"
export * from "./SwModalWindow.vue?vue&type=script&lang=js"
import style0 from "./SwModalWindow.vue?vue&type=style&index=0&id=6502bd47&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports